/*
 * Native-bundle add-to-cart hotfix (v2).
 * This file is referenced by snippets/entry.liquid and sections/main-product.liquid.
 *
 * Shopify native bundles (variants with requiresComponents) reject /cart/add.js
 * requests that carry a selling_plan (HTTP 422: "The bundle product ... cannot be
 * added to the cart"). This script only activates on product pages where the
 * section sets window.nativeBundleProduct === true and:
 *   1. Intercepts the main ATC button click in capture phase and performs a
 *      clean one-time add: { id, quantity } — never selling_plan.
 *   2. Strips selling_plan from any other fetch/XHR request to /cart/add.js
 *      that targets this bundle product's variants (stale cached JS, sticky
 *      ATC bars, upsell links).
 * Non-bundle products and other pages are untouched.
 */
(function () {
  if (window.__themeateryCartSingleAddHotfixV2) return;
  window.__themeateryCartSingleAddHotfixV2 = true;

  function isNativeBundlePage() {
    return window.nativeBundleProduct === true;
  }

  function bundleVariantIds() {
    var ids = [];
    if (Array.isArray(window.productVariants)) {
      window.productVariants.forEach(function (v) {
        if (v && v.id) ids.push(Number(v.id));
      });
    }
    if (window.activeVariant && window.activeVariant.id) {
      ids.push(Number(window.activeVariant.id));
    }
    return ids;
  }

  function isBundleVariant(id) {
    return bundleVariantIds().indexOf(Number(id)) !== -1;
  }

  function isCartAddUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname === '/cart/add.js';
    } catch (error) {
      return String(url || '').indexOf('/cart/add') !== -1;
    }
  }

  /* ---------- payload sanitizing (fetch + XHR safety net) ---------- */

  function sanitizeItem(item) {
    if (!item || !isBundleVariant(item.id)) return item;
    if ('selling_plan' in item) delete item.selling_plan;
    if (item.properties && typeof item.properties === 'object' && 'selling_plan' in item.properties) {
      delete item.properties.selling_plan;
    }
    return item;
  }

  function sanitizeJsonBody(raw) {
    var body;
    try {
      body = JSON.parse(raw);
    } catch (error) {
      return null;
    }
    if (!body || typeof body !== 'object') return null;

    if (Array.isArray(body.items)) {
      body.items = body.items.map(sanitizeItem);
    } else {
      sanitizeItem(body);
    }
    return JSON.stringify(body);
  }

  function sanitizeUrlEncodedBody(raw) {
    try {
      var params = new URLSearchParams(raw);
      var id = params.get('id') || params.get('items[0][id]');
      if (!id || !isBundleVariant(id)) return null;
      var changed = false;
      ['selling_plan', 'items[0][selling_plan]', 'properties[selling_plan]'].forEach(function (key) {
        if (params.has(key)) {
          params.delete(key);
          changed = true;
        }
      });
      return changed ? params.toString() : null;
    } catch (error) {
      return null;
    }
  }

  function sanitizeRawBody(raw) {
    if (!isNativeBundlePage() || !raw || typeof raw !== 'string') return null;
    if (raw.indexOf('selling_plan') === -1) return null;
    var trimmed = raw.charAt(0);
    if (trimmed === '{' || trimmed === '[') return sanitizeJsonBody(raw);
    return sanitizeUrlEncodedBody(raw);
  }

  function patchFetch() {
    if (typeof window.fetch !== 'function' || window.fetch.__bundleHotfixed) return;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (isNativeBundlePage() && isCartAddUrl(url) && init && typeof init.body === 'string') {
          var sanitized = sanitizeRawBody(init.body);
          if (sanitized !== null) {
            init = Object.assign({}, init, { body: sanitized });
          }
        }
      } catch (error) {
        /* fall through with the original request */
      }
      return originalFetch.call(this, input, init);
    };
    window.fetch.__bundleHotfixed = true;
  }

  function patchXhr() {
    var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!proto || proto.open.__bundleHotfixed) return;

    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__bundleHotfixCartAdd = isCartAddUrl(url);
      return originalOpen.apply(this, arguments);
    };
    proto.open.__bundleHotfixed = true;

    proto.send = function (body) {
      if (this.__bundleHotfixCartAdd && typeof body === 'string') {
        var sanitized = sanitizeRawBody(body);
        if (sanitized !== null) body = sanitized;
      }
      return originalSend.call(this, body);
    };
  }

  /* ---------- direct one-time add for the main ATC button ---------- */

  function selectedQuantity(button) {
    var gbb = document.querySelector('.product__gbb input[name="gbb-option"]:checked');
    if (gbb && Number(gbb.value) > 0) return Number(gbb.value);
    try {
      var root = button.closest('[x-data]');
      if (window.Alpine && root) {
        var data = window.Alpine.$data(root);
        if (data && Number(data.qtyCounter) > 0) return Number(data.qtyCounter);
      }
    } catch (error) {
      /* fall back to 1 */
    }
    return 1;
  }

  function activeVariantId(button) {
    try {
      var root = button.closest('[x-data]');
      if (window.Alpine && root) {
        var data = window.Alpine.$data(root);
        if (data && data.activeVariant && data.activeVariant.id) return Number(data.activeVariant.id);
      }
    } catch (error) {
      /* fall back to the section-rendered variant */
    }
    return window.activeVariant ? Number(window.activeVariant.id) : null;
  }

  function cartStore() {
    try {
      return window.Alpine && typeof window.Alpine.store === 'function' ? window.Alpine.store('cart') : null;
    } catch (error) {
      return null;
    }
  }

  function refreshCartAndOpen() {
    return window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var store = cartStore();
        if (store) {
          if (typeof store.updateCart === 'function') store.updateCart(cart);
          store.cartError = '';
          store.isOpen = true;
        }
        if (window.CartJS && window.CartJS.cart) window.CartJS.cart = cart;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  }

  function surfaceError(message) {
    var store = cartStore();
    if (store) {
      store.cartError = message;
    } else {
      window.alert(message);
    }
  }

  function handleBundleAtcClick(event) {
    if (!isNativeBundlePage()) return;

    var button = event.target && event.target.closest
      ? event.target.closest('.product__cta .product__cta-button')
      : null;
    if (!button) return;
    /* leave the Klaviyo back-in-stock trigger alone on sold-out pages */
    if (button.classList.contains('klaviyo-bis-trigger') || button.closest('.product__cta--notify')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.__bundleAtcBusy) return;

    var variantId = activeVariantId(button);
    if (!variantId) {
      surfaceError('Unable to determine the product variant. Please refresh the page.');
      return;
    }

    button.__bundleAtcBusy = true;
    button.setAttribute('aria-busy', 'true');

    window.fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: selectedQuantity(button) })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return { description: 'Something went wrong. Please try again.' };
        }).then(function (error) {
          throw error;
        });
      }
      return response.json();
    }).then(function () {
      return refreshCartAndOpen();
    }).catch(function (error) {
      surfaceError(error && (error.description || error.message) ? (error.description || error.message) : 'Something went wrong. Please try again.');
    }).then(function () {
      button.__bundleAtcBusy = false;
      button.removeAttribute('aria-busy');
    });
  }

  patchFetch();
  patchXhr();
  document.addEventListener('click', handleBundleAtcClick, true);
  if (isNativeBundlePage()) {
    console.log('[themeatery] native-bundle ATC hotfix v2.1 active for variant', window.activeVariant && window.activeVariant.id);
  }
})();
